var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.648 10.526 2.826 2.826a2 2 0 0 0-2.826-2.826Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.121 18.242a9.057 9.057 0 0 1-2.12.258c-2.255 0-4.278-.895-5.853-1.908a18.298 18.298 0 0 1-3.411-2.877 1.856 1.856 0 0 1-.119-2.4 16.3 16.3 0 0 1 2.213-2.363L6.25 10.37a14.28 14.28 0 0 0-1.97 2.066 16.27 16.27 0 0 0 2.95 2.474c1.396.897 3.04 1.59 4.77 1.59.123 0 .246-.003.369-.01l1.752 1.752Zm1.545-2.698 1.477 1.477c.245-.139.482-.283.71-.429a18.298 18.298 0 0 0 3.41-2.877 1.856 1.856 0 0 0 .12-2.4c-.574-.752-1.69-2.064-3.262-3.196C16.55 6.987 14.471 6 12.001 6c-1.772 0-3.342.507-4.668 1.212l1.494 1.494C9.786 8.276 10.85 8 12 8c1.922 0 3.599.767 4.952 1.742 1.295.932 2.247 2.022 2.77 2.694a16.27 16.27 0 0 1-2.952 2.474c-.353.227-.722.441-1.104.634Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4 5 15 15",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVisible);
export default __webpack_public_path__ + "static/media/not-visible.06550080ef2b1ee3521298a05e7e7a9c.svg";
export { ForwardRef as ReactComponent };